import React from "react";
import { FaBars } from "react-icons/fa";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../store/reducers/authSlice";

interface HeaderProps {
  toggleSideNav: () => void;
}

const Header = ({ toggleSideNav }: HeaderProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logoutHandler = () => {
    localStorage.removeItem("user_token");
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div className="bg-primary p-4 flex items-center justify-between">
      <div className={"flex items-center gap-5"}>
        <img src={"/logo.png"} alt="logo" width={130} />
        <FaBars
          className={"text-white text-xl cursor-pointer"}
          onClick={toggleSideNav}
        />
      </div>
      <RiLogoutCircleRLine
        className={"text-white text-2xl cursor-pointer"}
        onClick={logoutHandler}
      />
    </div>
  );
};

export default Header;
